import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export function Activities() {
    return (
        <Card className="mb-4" border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="mb-0 font-weight-bolder">
                    <span className="text-pp-primary">Activities</span>
                </Card.Title>
                <Row className="mt-3">
                    <Col xs={12}>
                        <Link to="/ManageActivities">
                            <Button
                                className="font-weight-bold"
                                variant="pp-primary">
                                View and Manage Activity
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}